import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { Button, Flex, Tag, Tooltip } from '@decisiv/ui-components';
import Times from '@decisiv/iconix/lib/components/Times';
import localCache from '../../../utils/localCache';
import { STORAGE_KEYS } from '../../../utils/storageKeys';

export default function SelectedFilters({
  items,
  clearAll,
  form,
  setForm,
  setTempForm,
}) {
  const fieldsNameMap = {
    nameSrm: t`Name/SRM Account`,
    category: t`Category`,
    audience: t`Audience`,
    serviceNetwork: t`Service Network`,
    trigger: t`Trigger Type`,
    events: t`Application Events`,
    commands: t`Commands`,
    active: t`Visibility`,
    published: t`Visibility`,
    cache: t`Cache`,
    circuitBreaker: t`Circuit Breaker`,
    autoRetry: t`Automatic Retry`,
    metadata: t`Metadata`,
    metadataKey: t`Metadata Key`,
    metadataValue: t`Metadata Value`,
    executionConditions: t`Execution Conditions`,
  };

  // Free-text filters reset to an empty string; radio filters reset to 'Both'.
  const textInputFields = ['metadataKey', 'metadataValue'];

  const handleTagRemoval = (event) => {
    const newForm = { ...form };
    const key = Object.keys(event.filter)[0];
    const value = Object.values(event.filter)[0];

    if (Array.isArray(newForm[key])) {
      // If the key corresponds to an array, remove the specified value
      const index = newForm[key].indexOf(value);
      if (index !== -1) {
        newForm[key].splice(index, 1);
      }
    } else {
      // Free-text filters clear to '', radio filters reset to 'Both'
      newForm[key] = textInputFields.includes(key) ? '' : 'Both';
    }

    localCache.set(STORAGE_KEYS.FILTER_CACHE, newForm);
    setForm(newForm);
    setTempForm(newForm);
  };

  return (
    <>
      <Flex name="advancedFilterTags" marginLeft={1} flexWrap="wrap">
        {items?.map((sn) => (
          <Tooltip
            key={`${sn.field}:${sn.value}`}
            target={
              <Flex marginLeft={0.5}>
                <Tag
                  text={sn.value}
                  variant="outline"
                  action={(e) => {
                    handleTagRemoval({
                      event: e,
                      filter: { [`${sn.field}`]: sn.value },
                    });
                  }}
                  actionIntent="danger"
                  actionAttributes={{ 'aria-label': 'Expand' }}
                  actionIcon={Times}
                />
              </Flex>
            }
          >
            {fieldsNameMap[sn.field]}
          </Tooltip>
        ))}
      </Flex>
      <Flex style={{ marginLeft: 'auto' }}>
        <Button
          text={t`Clear All`}
          size="small"
          variant="ghost"
          onClick={clearAll}
        />
      </Flex>
    </>
  );
}

SelectedFilters.propTypes = {
  clearAll: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  setTempForm: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object]).isRequired)
    .isRequired,
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
